import { useState, useEffect } from 'react';
import { assemblyService } from 'services/api';
import InfoModal from './InfoModal';
import styles from './AnexosModal.module.css';

const fmtSizeAnexo = (b) => !b ? '' : b < 1024 ? `${b} B` : b < 1048576 ? `${(b/1024).toFixed(0)} KB` : `${(b/1048576).toFixed(1)} MB`;

export default function AnexosModal({ assembly, onClose }) {
  const [docs,  setDocs]  = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    assemblyService.documents(assembly.id)
      .then(r => setDocs(r.data || []))
      .catch(err => setError(
        err.response?.status === 404
          ? 'Función no disponible — actualiza el servidor (falta la migración de Anexos).'
          : (err.response?.data?.message || 'No se pudieron cargar los anexos.')
      ));
  }, [assembly.id]);

  const download = async (d) => {
    try {
      const r = await assemblyService.downloadDocument(assembly.id, d.id);
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      a.href = url; a.download = d.original_name; a.click();
      URL.revokeObjectURL(url);
    } catch { setError('No se pudo descargar el documento.'); }
  };

  return (
    <InfoModal title="Anexos" icon="fa-paperclip" color="#f79009" onClose={onClose}>
      <p className={styles.intro}>
        Documentos de soporte de la asamblea <strong>#{assembly.number_assembly}</strong> — {assembly.property?.name}.
        Aquí encuentras lo que publica la administración: presupuesto, estados financieros, informe de gestión,
        acta anterior, proyecto de reforma, cotizaciones, dictamen del revisor fiscal, hojas de vida de candidatos.
      </p>
      {error ? (
        <div className={styles.error}>{error}</div>
      ) : docs === null ? (
        <div className={styles.cargando}><div className={`spinner ${styles.spinnerChico}`} /></div>
      ) : docs.length === 0 ? (
        <div className={styles.vacio}>
          <i className={`fas fa-folder-open ${styles.iconoCarpeta}`} />
          <div className={styles.vacioTexto}>No hay anexos disponibles para esta asamblea.</div>
        </div>
      ) : (
        <div className={styles.lista}>
          {docs.map(d => (
            <button key={d.id} onClick={() => download(d)}
              className={styles.documento}>
              <i className={`fas fa-file ${styles.documentoIcono}`} />
              <div className={styles.documentoTexto}>
                <div className={styles.documentoNombre}>{d.name}</div>
                <div className={styles.documentoPeso}>{fmtSizeAnexo(d.size)}</div>
              </div>
              <i className={`fas fa-download ${styles.descargaIcono}`} />
            </button>
          ))}
        </div>
      )}
    </InfoModal>
  );
}
